import WarningTriangleIcon from './icons/WarningTriangleIcon.jsx';

const ErrorMessageBlock = ({ className, children }) => {
    return (
        <div
            className={`bg-red-500 text-white rounded-md p-4 flex text-sm ${className}`}
        >
            <WarningTriangleIcon className="w-6 h-6 mx-3 flex-shrink-0" />
            <div>{children}</div>
        </div>
    );
};

export default ErrorMessageBlock;
